import React from 'react';
import { Box, Typography } from '@mui/material';

export const Title = "You're invited to an AI interview"

export function getText(jobTitle, companyName) {
    return `Thank you for your interest in the ${
        jobTitle
            ? ` ${jobTitle} position${companyName ? ` at ${companyName}` : ''}`
            : 'this position'
    }! We would like to invite you to speak with an AI Agent. We hope to learn more about your background and skills that would make you a good fit for the job.`;
}

export function getPracticeText(companyName, jobTitle, practiceQuestion, isPremium = false) {
    return (
        <Box>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                You're practicing a real interview question from {companyName}!
            </Typography>
            {practiceQuestion && (
                <Box sx={{ 
                    p: 2, 
                    mb: 2, 
                    bgcolor: isPremium ? '#f0f8ff' : 'rgba(0, 0, 0, 0.04)', 
                    border: isPremium ? '1px solid #e3f2fd' : '1px solid rgba(0, 0, 0, 0.08)',
                    borderRadius: 1,
                    borderLeft: isPremium ? '4px solid #1976d2' : '4px solid #666'
                }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: isPremium ? '#1565c0' : 'text.secondary' }}>
                        📝 Question Preview:
                    </Typography>
                    {isPremium ? (
                        <Typography variant="body1" sx={{ 
                            fontStyle: 'italic',
                            color: '#333',
                            lineHeight: 1.6
                        }}>
                            "{practiceQuestion}"
                        </Typography>
                    ) : (
                        <Box>
                            <Typography variant="body1" sx={{ 
                                fontWeight: 500,
                                color: 'text.secondary',
                                mb: 1
                            }}>
                                🔒 Premium content - Question details are hidden
                            </Typography>
                            <Typography variant="body2" sx={{ 
                                color: 'text.secondary',
                                lineHeight: 1.5
                            }}>
                                You can still practice this question! The interviewer will reveal it during the session.
                            </Typography>
                        </Box>
                    )}
                </Box>
            )}
            <Typography variant="body1" sx={{ color: '#666' }}>
                This is a practice session using a real question from {companyName}'s interview process. 
                Practice as many times as you want to improve your skills!
            </Typography>
        </Box>
    );
}

export const WaitingContent = "Please wait for the mock interview to be ready"

export function RoundInfo(round){
    if(round === 'hr-round')
        return ["HR Round", "30 min"]
    if(round === 'prod-sense')
        return ["Product Sense", "45 min"]
    if(round === 'analytical-execution')
        return ["Analytical Execution", "45 min"]
    if(round === 'leadership')
        return ["Leadership", "45 min"]
    if(round === 'Quick Mock')
        return ["Quick Mock", "30 min"]
    return ["", ""]
}

export const languageMapping = {
    "bg": "Български",
    "ca": "Català",
    "zh": "中文（简体）",
    "zh-TW": "中文（繁體）",
    "zh-HK": "粤语",
    "cs": "Čeština",
    "da": "Dansk",
    "nl": "Nederlands",
    "nl-BE": "Nederlands (België)",
    "en": "English",
    "et": "Eesti",
    "fi": "Suomi",
    "fr": "Français",
    "fr-CA": "Français (Canada)",
    "de": "Deutsch",
    "de-CH": "Deutsch (Schweiz)",
    "el": "Ελληνικά",
    "hi": "हिन्दी",
    "hu": "Magyar",
    "id": "Bahasa Indonesia",
    "it": "Italiano",
    "ja": "日本語",
    "ko": "한국어",
    "lv": "Latviešu",
    "lt": "Lietuvių",
    "ms": "Bahasa Melayu",
    "no": "Norsk",
    "pl": "Polski",
    "pt": "Português",
    "pt-BR": "Português (Brasil)",
    "pt-PT": "Português (Portugal)",
    "ro": "Română",
    "ru": "Русский",
    "sk": "Slovenčina",
    "es": "Español",
    "es-419": "Español (Latinoamérica)",
    "sv": "Svenska",
    "sv-SE": "Svenska (Sverige)",
    "th": "ไทย",
    "tr": "Türkçe",
    "uk": "Українська",
    "vi": "Tiếng Việt"
};
